import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const createBillOfMaterialsWithAi = async (text) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/ai-bill-of-materials`, { text });
    return response.data;
  } catch (error) {
    console.error('Error creating bill of materials with AI:', error.response?.data || error);
    throw error;
  }
};
